import notifyToast from "../foundation/Toast/Toast";
import { config } from "./AppConfig";

/* eslint-disable no-async-promise-executor */
const request = async (url, data, options) => {
  return new Promise(async (resolve, reject) => {
    let rawResponse;
    if (!options?.method || !data) {
      rawResponse = await fetch(url);
    } else {
      rawResponse = await fetch(url, {
        method: options.method,
        ...(options.redirect && { redirect: options.redirect }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    }
    try {
      const content = await rawResponse.json();
      if (!rawResponse.ok) {
        reject({
          status: rawResponse.status,
          statusText: rawResponse.statusText,
          ...content,
        });
        if (rawResponse.status === 403) {
          // Assuming you have a toast notification function
          notifyToast({ message: "Access forbidden: You do not have permission to access this resource.", type: "error" });
        }
        return;
      }
      resolve(content);
    } catch (err) {
      reject(err);
    }
  });
};

class Fetcher {
  post(url, data, options) {
    return request(url, data, { method: "POST", redirect: options?.redirect });
  }
  get(url) {
    return request(url);
  }
  async uploadFile(url, file) {
    return new Promise(async (resolve, reject) => {
      const rawResponse = await fetch(url, {
        method: "POST",
        body: file,
      });
      if (rawResponse.ok) {
        const content = await rawResponse.json();
        resolve(content);
      } else {
        reject(rawResponse);
      }
    });
  }
  async uploadMultipart(url, formData) {
    const rawResponse = await fetch(url, {
      method: "POST",
      body: formData,
    });
    const content = await rawResponse.json().catch(() => ({}));
    if (!rawResponse.ok) {
      throw new Error(content.message || "File upload failed. Please try again.");
    }
    return content;
  }
  async pollJob(job) {
    const pollInterval = 7000;

    const response = await request(
      `${config.WEB_URL}/api/status/${job.name}/${job.id}`
    );
    if (response.status === "completed" || response.status === "failed") {
      return response;
    } else {
      return await this.timeout(job, pollInterval);
    }
  }
  async timeout(job, ms) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const resp = await this.pollJob(job);
        if (resp) {
          resolve(resp);
        }
      }, ms);
    });
  }
}
export default new Fetcher();
